import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { MeasurementTypeCard } from '../measurement-type-card';

const noop = () => {};

export const VisitConversionLiftNotAllowed = ({ title }) => {
  const i18n = useContext(I18nContext);
  const explanation = i18n.getString(_TL_("You can't measure visits or conversions because you haven't yet set up UET tags and conversion tracking."));
  return (
    <MeasurementTypeCard
      description={explanation}
      helpId="pop_BA_Experiments_VisitsConversions"
      isAllowed={false}
      isEnabled={false}
      onToggle={noop}
      title={title}
    />
  );
};

VisitConversionLiftNotAllowed.propTypes = {
  title: PropTypes.string.isRequired,
};
